// frontend/src/utils/clipboard.ts

/**
 * Copy text to clipboard with fallback for mobile browsers.
 * Uses navigator.clipboard when available, falls back to execCommand('copy').
 * Returns true on success, false on failure.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // Try modern API first
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Fall through to fallback
    }
  }

  // Fallback: hidden textarea + execCommand
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    // Prevent scrolling to bottom on iOS
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '-9999px';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    // iOS requires setSelectionRange
    textarea.setSelectionRange(0, text.length);

    // execCommand('copy') is deprecated but remains widely supported and
    // is our fallback for older mobile browsers and non-secure contexts.
    const success = document.execCommand('copy');
    document.body.removeChild(textarea);
    return success;
  } catch {
    return false;
  }
}
